import React from 'react';
import './portfolio.css';

const data = [
    {
        id: 1,
        image: "https://i.ibb.co/ZGHhbVZ/portfolio1.jpg",
        title: "Bangla Commerce - Team Project",
        github: "https://github.com/samian016/Bangla-Commerce",
        demo: "https://bangla-commerce.web.app/"
    },
    {
        id: 2,
        image: "https://i.ibb.co/hH0mMqq/portfolio2.jpg",
        title: "The Traveler - Full Stack Project",
        github: "https://github.com/mizanur919/Asi11_tourism_or_delivery_website_client_side",
        demo: "https://thetravelerassi11.netlify.app/"
    },
    {
        id: 3,
        image: "https://i.ibb.co/KVjRMNH/portfolio3.jpg",
        title: "Best Watch Point - Full Stack ",
        github: "https://github.com/mizanur919/Asi12_Best_Watch_Point_Client",
        demo: "https://bestwatchpoint.netlify.app/"
    },
    {
        id: 4,
        image: "https://i.ibb.co/kD0d9Tt/portfolio4.jpg",
        title: "Therapy Care Point - Appointment For Therapy",
        github: "https://github.com/mizanur919/Asi10_health_care_and_tips",
        demo: "https://assignment-therapy-care-point.web.app/"
    },
]

const Portfolio = () => {
    return (
        <section id='portfolio'>
            <h5>My Recent Work</h5>
            <h2>Portfolio</h2>

            <div className="container portfolio__container">
                {
                    data.map(({id, image, title, github, demo}) =>{
                        return(
                            <article key={id} className="portfolio__item">
                                <div className="portfolio__item-image">
                                    <img src={image} alt="" />
                                </div>
                                <h3>{title}</h3>
                                <div className="portfolio__item-cta">
                                    <a href={github} className='btn' target="_blank">GitHub</a>
                                    <a href={demo} className='btn btn-primary' target="_blank">Live Demo</a>
                                </div>
                            </article>
                        );
                    })
                }
            </div>
        </section>
    );
};

export default Portfolio;